export const environment = {
  production: false,
  base_url: 'https://signage-dev.azure-api.net',
  google_maps_api_key: 'AIzaSyD5utJJSyLtmOjTZnAWcW5HRsm4VjpGNHI',
};
